// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForKPITableRow = makeThemedStyles('KPITable.KPITableRow', () => ({
  KPITableRow: {
    display: 'table-row',
    paddingTop: '5px',
    paddingBottom: '5px',
    marginLeft: '0.4em',
    marginRight: '0.4em',
    borderTop: '1px solid #c3d4d6',
    '&:nth-child(1)': { borderTop: 'none' }
  },

  selectable: {
    cursor: 'pointer',
    '&:hover': { textDecoration: 'underline' }
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const KPITableRow: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForKPITableRow();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.KPITableRow, {
        [styles.selectable]: isVariantEnabled(props, 'selectable')
      })}
    >
      {props?.children}
    </div>
  );
};
export default KPITableRow;
